import app from 'flarum/forum/app';
export function allowedFeedbackTags() {
  try {
    const tags = JSON.parse(app.forum.attribute('huseyinfiliz.traderfeedback.feedbackActionTagFilter') || '[]');
    return Array.isArray(tags) ? tags.map(String) : [];
  } catch {
    return [];
  }
}
export function requiresFeedbackDiscussion() {
  return Boolean(app.forum.attribute('huseyinfiliz.traderfeedback.requireDiscussion') || app.forum.attribute('huseyinfiliz.traderfeedback.feedbackOnlyWhenLocked') || allowedFeedbackTags().length);
}
export function allowsFeedback(discussion) {
  if (!discussion) return false;
  const tags = allowedFeedbackTags();
  if (tags.length && !discussion.tags?.()?.some(tag => tag && tags.includes(tag.id()))) return false;
  return !app.forum.attribute('huseyinfiliz.traderfeedback.feedbackOnlyWhenLocked') || Boolean(discussion.isLocked?.());
}
flarum.reg.add('huseyinfiliz-traderfeedback', 'forum/utils/discussionRestrictions', { allowedFeedbackTags: allowedFeedbackTags,requiresFeedbackDiscussion: requiresFeedbackDiscussion,allowsFeedback: allowsFeedback, });